import { CategoryChartVisibilityFn } from "../categoryChart";
// import { queryCount } from "../misc";
import { getProviderCountAllKpisExist } from "../opendata";

export const doAllKpisForTheProvidersExist: CategoryChartVisibilityFn = async ({ locationAdminIds, kpis = [] }) => {
    const count = await getProviderCountAllKpisExist(kpis, locationAdminIds);

    return count > 0;

    // if (options?.skip) return false;

    // const count = await queryCount({
    //     query: gql
    // });

    // if (count == null) return false;

    // return count > 0;
};
